import { coerceBooleanProperty } from "@angular/cdk/coercion";
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from "@angular/core";

@Directive({
  selector: "[taInteract]"
})
export class InteractDirective {
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
  }
  private _disabled: boolean = false;

  @HostBinding("attr.tabindex")
  get tabIndex(): number {
    return !this.disabled ? 0 : -1;
  }

  @HostListener("keydown.space", ["$event"])
  onKeydown(e: Event): void {
    if (this.disabled) {
      return;
    }
    this.ensureSingleEventEmission(e);
    this.taInteract.emit();
  }

  @HostListener("click")
  onClick(): void {
    if (this.disabled) {
      return;
    }
    this.taInteract.emit();
  }

  @Output()
  taInteract: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(private elementRef: ElementRef) {}

  private get hostIsNativeButton(): boolean {
    const BUTTON_TAG_NAME = "BUTTON";
    const hostElement = this.elementRef.nativeElement as HTMLElement;
    return hostElement != null && hostElement.tagName === BUTTON_TAG_NAME;
  }

  private ensureSingleEventEmission(e: Event): void {
    if (e != null && this.hostIsNativeButton) {
      // With native buttons, focus + space also triggers the click handler.
      // By calling preventDefault, we stop the click handler and don't emit twice from taInteract
      e.preventDefault();
    }
  }
}
